import { post } from '../../../DAL/data-provider';
import {Response, EventUserRegistration, CancelEventSend, EventUserRegistrationWrapper} from '../interfaces';

export const sendContact = async (sendContact: EventUserRegistration) : Promise<Response> => {
    console.log(`sendContact:`,sendContact);
    return post('/api/events/send-contact', sendContact);
};
export const regEventUser = async (eventRegUser: EventUserRegistrationWrapper) : Promise<Response> => {
    console.log(`eventRegUser:${eventRegUser}`,eventRegUser);
    return post('/api/events/reg-event-user', eventRegUser);
};
export const cancelEventRSVP = async (cancelEventSend: CancelEventSend) : Promise<Response> => {
    console.log(`cancelEventSend:`,cancelEventSend);
    return post('/api/events/cancel-event', cancelEventSend);
};
export const checkIfUtmLSExists = () => {

    try {
        var localStorageItem = window.localStorage.getItem("utm_ls_object");
        if(!localStorageItem)
            return ;
        localStorageItem = decodeURIComponent(localStorageItem);
        var parsedUtm:any = localStorageItem && localStorageItem !== 'null' ? localStorageItem : null;

        var preloadEl = document.getElementById("utm-expires-days");
        if(!preloadEl || !preloadEl.textContent)
            return ;
        var utmExpireDaysSetting = undefined;
        try {
            utmExpireDaysSetting = JSON.parse(preloadEl.textContent?.trim());
        } catch (ex) {
        }
        var isExpired = parsedUtm ? checkIfLsObjectExpired(utmExpireDaysSetting, parsedUtm?.firstTimestamp) : null;
        if (!isExpired){

            let data = null;

            try{
                data = JSON.parse(localStorageItem);
            }
            catch(ex){}

            return data;
        }
    } catch (ex) {
        return null;
    }

};
const checkIfLsObjectExpired = (utmExpireDays:any, lsFirstTimestamp:any) => {
    var date = new Date();
    var result = daysBetween(lsFirstTimestamp, date);
    if (result > utmExpireDays) {
        return true;
    }
    return false;

};

const daysBetween = (startDate:any, endDate:any) => {
    var millisecondsPerDay = 24 * 60 * 60 * 1000;
    var res:any = (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
    return res;
};
const treatAsUTC = (date:any) => {
    var result:any = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
};